import { Controller } from "@hotwired/stimulus"
import { useIntersection } from "stimulus-use"

export default class extends Controller {
  connect() {
    console.log("VideoLoopBlockComponentController connected")
    useIntersection(this)
  }

  appear(entry, observer) {
    this.dispatch("appear")
  }

  disappear(entry, observer) {
    this.dispatch("disappear")
  }
}
